///---------------------------------------------------------------------------
//! Copyright (C) ASQUARED SRL - All Rights Reserved
//* Unauthorized copying of this file, via any medium is strictly prohibited
//* Proprietary and confidential
//* Written by Alexandru Gârbacea <g99.alex@yahoo.com>, September 2022
//? @author g99.alex@yahoo.com
///---------------------------------------------------------------------------

import React, {useState} from 'react'
import {
    faCaretUp,
    faGears,
    faMagnifyingGlass,
    faPlusMinus,
    faDownload,
    faTriangleExclamation,
    faPercent,
    faPenToSquare,
    faListUl,
    faFilter,
    faArrowsLeftRight,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactTooltip from 'react-tooltip';

import { createNotification } from '../../services/NotificationService';
import { getMonthName } from '../../services/DateService';
import { useAuth } from '../../context/AuthContext';
import ExcelResultTable from './ExcelResultTable';



const HandleExcel = ({startData}) => {

    const [oldGenerated, setOldGenerated] = useState([])
    const handleSetOld = (data) => {
        setOldGenerated(data)
        data.length > 0 && setData(prev => ({...prev, isOldData:true, oldData:data }))
    }
    const [topOpen, setTopOpen] = useState(true);
    const [data, setData]       = useState({
        ...startData,
        setOldData: handleSetOld,
        oldData:   oldGenerated,
        fullWidth: false,
        isOldData: false,
        detailed:  false,
        onlyReq:   false,
        showErr:   false,
        valStat:   false,
        reviz:     false,
    })
    const [actions, setActions] = useState({
        exportExcelErr: false,
        downloadOldXML: false,
        calcValStat:    false,
        exportExcel:    false,
        generate:       false,
        checkVat:       false,
    })

    const {
        companies,
        userData,
        layouts
    } = useAuth()

    const { data: uData, subscriptions: uSub } =  userData

    const toolTipData = [
        `Calculează valoarea statistică și modifică procentele din meniul "Calcul val stat"`,
        `Marchează tipul declarației ca "revizuită"`,
        `La generarea fișierului XML nu se vor cumula valorile`,
        `Afișează doar erorile în tabelul de mai jos`,
        `Afișează doar coloanele necesare în tabelul de mai jos`,
        `Mărește lățimea coloanelor din tabelul de mai jos`
    ]

    //? the action each toolbar button toggles, by button type
    const ACTION_KEY = {
        0: 'generate',
        1: 'checkVat',
        3: 'exportExcel',
        4: 'calcValStat',
        5: 'exportExcelErr',
        6: 'downloadOldXML',
    }

    const NOT_IN_SUBSCRIPTION = 'Această funcție nu este disponibilă în abonamentul actual'

    //-----------------------------------------------------------------------------------------
    //* \brief
    //? Why an action cannot be run right now, or null when it can.
    //?
    //? The reason has to travel with the answer. "Verificare VAT" is off both for a plan that
    //? does not include it and for an achiziții machetă - arrivals carry no partner VAT, so
    //? there is nothing to check - and the old code answered both with a bare boolean, which
    //? handleClick then reported as "nu este disponibilă în abonamentul actual". Every Plus,
    //? Premium and Professional customer working on arrivals - the common case, and the type
    //? of the example file we ship - was told their plan does not include a feature they paid
    //? for. The same applied to "Calcul val stat", refused with the same wording when the only
    //? thing missing was the checkbox above it.
    //-----------------------------------------------------------------------------------------
    const unavailableReason = (type) => {
        const sub = (uSub && uSub[0]) || {}
        const layoutType = layouts[data.layout] ? layouts[data.layout].type : ''

        switch(type) {
            // generare
            case 0: return null
            // verificare vat
            case 1:
                if (!sub.cifCheck) return NOT_IN_SUBSCRIPTION
                if (layoutType === 'achizitii') return 'Declarațiile de achiziții nu conțin codul '
                    + 'TVA al partenerului, deci nu este nimic de verificat. Verificarea VAT este '
                    + 'disponibilă pentru machetele de tip livrări.'
                return null
            // schimb valutar
            case 2: return 'Această funcție nu este disponibilă'
            // export excel
            case 3: return null
            // val stat
            case 4:
                if (!sub.valStatCalc) return NOT_IN_SUBSCRIPTION
                if (!data.valStat) return 'Bifați "Calcul valoare statistică" din opțiunile de '
                    + 'mai sus pentru a putea folosi această funcție.'
                return null
            // errors excel
            case 5: return null
            // download generated
            case 6: return oldGenerated.length < 1 ? 'Nu există un fișier generat încă' : null
            default: return null
        }
    }

    const isDisabled = (type) => unavailableReason(type) !== null

    const handleClick = (type) => {
        const reason = unavailableReason(type)
        if (reason) return createNotification('info', reason)

        const key = ACTION_KEY[type]
        if (!key) return
        setActions(prev => ({...prev, [key]: !prev[key]}))
    }

    return (
        <div className={`handle-section`} >
            <div className={`handle-top-info ${topOpen ? '' : 'collapsed'}`}>
                <div id='collapse-btn' onClick={() => setTopOpen(!topOpen)}>
                    <FontAwesomeIcon id='inside' icon={faCaretUp} />
                </div>
                <div className='handle-small-wrapper'>

                    {/* Info bar */}
                    <div className='handle-info-bar'>
                        <div className='handle-info-item'>
                            <span className='handle-info-label'>Perioadă</span>
                            <span className='handle-info-value'>{data.month} ({getMonthName(data.month)}) - {data.year}</span>
                        </div>
                        <div className='handle-info-item'>
                            <span className='handle-info-label'>Tip</span>
                            <span className='handle-info-value'>{layouts[data.layout].type.toUpperCase()}</span>
                        </div>
                        <div className='handle-info-item'>
                            <span className='handle-info-label'>Firm{data.tert ? 'e' : 'ă'}</span>
                            <span className='handle-info-value'>{data.tert ?
                                <>
                                <span data-tip data-for="my-comp">{`${uData.cui} `}</span>
                                -<span data-tip data-for="for-comp">{` ${companies[data.compFor].cif}`}</span>
                                </>
                                : <span data-tip data-for="my-comp">{`${uData.cui}`}</span>}
                            </span>
                        </div>
                    </div>

                    {/* Options grid */}
                    <div className='handle-options-grid'>
                        <div className='checkbox-wrapper option-chip'>
                            <input className='checkbox' value={data.valStat} defaultChecked={data.valStat}
                                onChange={(e) => setData(prev => ({...prev, valStat: e.target.checked}))}
                                type="checkbox" id="valStat" name="valStat" title='Calcul valoare statistică'/>
                            <label htmlFor="valStat" data-tip="0" data-for="select-tooltip">
                                <FontAwesomeIcon className='option-chip__icon' icon={faPercent} />
                                <span className='option-chip__text'>Calcul valoare statistică</span>
                            </label>
                        </div>

                        <div className='checkbox-wrapper option-chip'>
                            <input className='checkbox' value={data.reviz} defaultChecked={data.reviz}
                                onChange={(e) => setData(prev => ({...prev, reviz: e.target.checked}))}
                                type="checkbox" id="reviz" name="reviz" title='Declarație revizuită'/>
                            <label htmlFor="reviz" data-tip="1" data-for="select-tooltip">
                                <FontAwesomeIcon className='option-chip__icon' icon={faPenToSquare} />
                                <span className='option-chip__text'>Declarație revizuită</span>
                            </label>
                        </div>

                        <div className='checkbox-wrapper option-chip'>
                            <input className='checkbox' value={data.detailed} defaultChecked={data.detailed}
                                onChange={(e) => setData(prev => ({...prev, detailed: e.target.checked}))}
                                type="checkbox" id="detailed" name="detailed" title='XML detaliat'/>
                            <label htmlFor="detailed" data-tip="2" data-for="select-tooltip">
                                <FontAwesomeIcon className='option-chip__icon' icon={faListUl} />
                                <span className='option-chip__text'>XML detaliat</span>
                            </label>
                        </div>

                        {/* pulses while the table below still contains error cells - pure CSS,
                            driven by :has() on the section, so no extra state and no re-render */}
                        <div className='checkbox-wrapper option-chip option-chip--errors'>
                            <input className='checkbox' value={data.showErr} defaultChecked={data.showErr}
                                onChange={(e) => setData(prev => ({...prev, showErr: e.target.checked}))}
                                type="checkbox" id="showErr" name="showErr" title='Afișează doar erori'/>
                            <label htmlFor="showErr" data-tip="3" data-for="select-tooltip">
                                <FontAwesomeIcon className='option-chip__icon' icon={faTriangleExclamation} />
                                <span className='option-chip__text'>Afișează doar erori</span>
                            </label>
                        </div>

                        <div className='checkbox-wrapper option-chip'>
                            <input className='checkbox' value={data.onlyReq} defaultChecked={data.onlyReq}
                                onChange={(e) => setData(prev => ({...prev, onlyReq: e.target.checked}))}
                                type="checkbox" id="onlyReq" name="onlyReq" title='Afișează doar necesare'/>
                            <label htmlFor="onlyReq" data-tip="4" data-for="select-tooltip">
                                <FontAwesomeIcon className='option-chip__icon' icon={faFilter} />
                                <span className='option-chip__text'>Afișează doar necesare</span>
                            </label>
                        </div>

                        <div className='checkbox-wrapper option-chip'>
                            <input className='checkbox' value={data.fullWidth} defaultChecked={data.fullWidth}
                                onChange={(e) => setData(prev => ({...prev, fullWidth: e.target.checked}))}
                                type="checkbox" id="fullWidth" name="fullWidth" title='Lățime întreagă tabel'/>
                            <label htmlFor="fullWidth" data-tip="5" data-for="select-tooltip">
                                <FontAwesomeIcon className='option-chip__icon' icon={faArrowsLeftRight} />
                                <span className='option-chip__text'>Lățime întreagă tabel</span>
                            </label>
                        </div>
                    </div>

                    {/* Action toolbar */}
                    <div className='handle-toolbar'>
                        <div className='handle-toolbar-group'>
                            <div className={`handle-action-btn primary${isDisabled(0) ? ' disabled' : ''}`}
                            onClick={() => handleClick(0)}>
                                <FontAwesomeIcon icon={faGears} /> Generare</div>

                            <div data-tip data-for="download" className={`handle-action-btn primary${isDisabled(6) ? ' disabled' : ''}`}
                            onClick={() => handleClick(6)}>
                                <FontAwesomeIcon icon={faDownload} /></div>
                        </div>

                        <div className='handle-toolbar-divider'></div>

                        <div className='handle-toolbar-group'>
                            {/* the reason is on the button itself - a greyed out control that
                                only explains itself once clicked reads as broken */}
                            <div className={`handle-action-btn accent${isDisabled(1) ? ' disabled' : ''}`}
                            title={unavailableReason(1) || ''}
                            onClick={() => handleClick(1)}>
                                <FontAwesomeIcon icon={faMagnifyingGlass} /> Verificare VAT</div>

                            <div className={`handle-action-btn accent${isDisabled(4) ? ' disabled' : ''}`}
                            title={unavailableReason(4) || ''}
                            onClick={() => handleClick(4)}>
                                <FontAwesomeIcon icon={faPlusMinus} /> Calcul val stat</div>
                        </div>

                        <div className='handle-toolbar-divider'></div>

                        <div className='handle-toolbar-group'>
                            <div className={`handle-action-btn${isDisabled(3) ? ' disabled' : ''}`}
                            onClick={() => handleClick(3)}>
                                <FontAwesomeIcon icon={faDownload} /> Exportă excel</div>

                            <div className={`handle-action-btn${isDisabled(5) ? ' disabled' : ''}`}
                            onClick={() => handleClick(5)}>
                                <FontAwesomeIcon icon={faTriangleExclamation} /> Exportă erori</div>
                        </div>
                    </div>

                </div>
            </div>
            <ExcelResultTable data = {data} actions = {actions} />
            <ReactTooltip effect="solid" id='for-comp' type="success">{companies[data.compFor].name}</ReactTooltip>
            <ReactTooltip effect="solid" id='my-comp' type="success">{companies[0].name}</ReactTooltip>
            <ReactTooltip effect="solid" id='download' type="success"><h3>Descarcă fișierul deja generat</h3></ReactTooltip>

            <ReactTooltip effect="solid" id='select-tooltip' type="info" 
            getContent={(dataTip) => `${toolTipData[parseInt(dataTip)]}`} />
        </div>
    )
}

export default HandleExcel